import useClickLogger from 'api/ClickLogger';
import AccordionLocalContent from 'components/AccordionLocalContent';
import React from 'react';

function LocalPageTemplate({
  organization,
  body,
  _click,
  url,
}) {
  const { trackResultClick } = useClickLogger(_click, url);
  return (
    <AccordionLocalContent heading={organization} onClick={trackResultClick}>
      <span dangerouslySetInnerHTML={{ __html: body }} />
    </AccordionLocalContent>
  )
}

export default LocalPageTemplate
